import { render, staticRenderFns } from "./AgentsAssignedAndAvailable.vue?vue&type=template&id=15b2b488"
import script from "./AgentsAssignedAndAvailable.vue?vue&type=script&lang=js"
export * from "./AgentsAssignedAndAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports